import React, { useEffect } from "react";
import { stopPropagation } from "../../../../../helpers/ObjectHelpers";
import MapPropertiesService from "../../../services/MapPropertiesService";
import {
    useSetPanelState,
    usePilotCertificateCoastalSegmentPerson
} from "../../../hooks/useMapStore";
import { IconPicker } from "../../../../icons/IconPicker";

export const MapControlPilotCertificateCoastalSegments = () => {

    const setPanelState = useSetPanelState();
    const pilotCertificateCoastalSegmentPerson = usePilotCertificateCoastalSegmentPerson();

    const panelStates = MapPropertiesService.panelStates;

    useEffect(() => {
        if (!pilotCertificateCoastalSegmentPerson) {
            setPanelState("");
            return;
        }
        
        setPanelState(panelStates.PilotCertificateCoastalSegments);
        
    }, [pilotCertificateCoastalSegmentPerson, setPanelState, panelStates.PilotCertificateCoastalSegments]);

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        stopPropagation(e);
        setPanelState(panelStates.PilotCertificateCoastalSegments);
    };

    if (!pilotCertificateCoastalSegmentPerson) {
        return null;
    }

    return (
        <div className="google-map-control google-map-control-button" onClick={handleClick}>
            <IconPicker icon="squares-four" size={20} weight="duotone" />
        </div>
    );
};
